import { useEffect } from 'react';
import AuthenticatedLayout from '../../Layouts/AuthenticatedLayout';
import RegularButton from '../../Components/RegularButton';
import TextInput from '../../Components/TextInput';
import Dropdown from '../../Components/Dropdown';
import { Head } from '@inertiajs/react';
import { HiOutlineDotsVertical } from "react-icons/hi";
import toast, { Toaster } from 'react-hot-toast'

const ManageTenants = ({ auth, tenants, status }) => {

    const { data } = tenants;

    useEffect(() => {
        // console.log(data);
        if(status) {
            if(status.includes('Master') || status.includes('yet')){
                toast.error(status);
                return;
            }

            toast.success(status);
        }

    }, [status]);

    const headers = [
        'Name',
        'Type',
        'Domain',
        'Status',
        'Created At',
        'Operations',
        '',
    ];

  return (
    <AuthenticatedLayout
    user={auth.user}
    header="Tenants"
    >
        <Head title="Tenants" />

        <div className="py-12">
            <div className="w-full mx-auto px-6 lg:px-12">
                <div className="bg-white overflow-hidden shadow-md sm:rounded-lg">
                    <div className="p-6">
                        <div className="flex items-center justify-center">
                            <div className="flex flex-col items-start justify-center w-full gap-8 px-8">
                                <h3 className='text-xl lg:text-4xl text-center mx-auto text-slate-400'>Manage Tenants</h3>
                                <Toaster toastOptions={{duration: 5000,
                                style: {
                                    width: 'max-content',
                                    background: '#363636',
                                    color: '#fff',
                                  },}} />
                                <div className="container px-4 mx-auto sm:px-8">
                                    <div className="py-4 md:mt-8">
                                        <div className="flex flex-row items-center justify-between w-full mb-1 sm:mb-0">
                                            <RegularButton
                                            href={route('tenant.create')}
                                            className="bg-emerald-500 hover:bg-emerald-400 focus:bg-emerald-300 active:bg-emerald-600 focus:ring-emerald-300" >
                                                Create
                                            </RegularButton>

                                            <div className="text-end">
                                                <div className="flex flex-col justify-center w-3/4 max-w-sm space-y-3 md:flex-row md:w-full md:space-x-3 md:space-y-0">
                                                    <div className="relative">
                                                        <TextInput
                                                        type="text"
                                                        name="query"
                                                        global={false}
                                                        className="block w-full px-5 py-3 text-base text-neutral-700 placeholder-stone-500 bg-stone-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-stone-300"
                                                        placeholder="Search..."
                                                        onChange={(e) => console.log('searching...')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="px-4 py-8 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
                                            <div className="inline-flex min-w-full pb-36 overflow-hidden rounded-lg">
                                                <table className="min-w-full leading-normal">
                                                    <thead>
                                                        <tr className='bg-stone-100'>
                                                        {headers?.map((header, i) => (
                                                            <th key={i+1} scope="col" className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase border-b border-gray-200">
                                                                {header}
                                                            </th>
                                                        ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data && data?.map((tenant, tx) => (
                                                            <tr key={tx+1} className={`${data.length === tx+1 ?"shadow rounded-b-xl" : ""}`}>
                                                                <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                                    <div className="flex items-center">
                                                                        <div className="flex-shrink-0">
                                                                            <div className="relative block">
                                                                                <img alt="profil" src={tenant?.logo} className="mx-auto object-cover rounded-full h-10 w-10"/>
                                                                            </div>
                                                                        </div>
                                                                        <div className="ml-3">
                                                                            <p className="text-gray-900 whitespace-no-wrap">
                                                                                {tenant?.id}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                                    <span className="relative inline-block px-3 py-1 font-semibold leading-tight text-violet-900">
                                                                        <span aria-hidden="true" className="absolute inset-0 rounded-full opacity-50 bg-violet-200">
                                                                        </span>
                                                                        <span className="relative">
                                                                            {tenant?.type}
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                                <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                                    <p className="text-gray-900 whitespace-no-wrap">
                                                                        <a href={`https://${tenant?.domain}/`} target='_blank'>{tenant?.domain}</a>
                                                                    </p>
                                                                </td>
                                                                <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                                    <span className={`relative inline-block px-3 py-1 font-semibold leading-tight ${tenant?.status_val ? "text-emerald-900" : "text-orange-900"}`}>
                                                                        <span aria-hidden="true" className={`absolute inset-0 rounded-full opacity-50 ${tenant?.status_val ? "bg-emerald-200" : "bg-orange-200"}`}>
                                                                        </span>
                                                                        <span className="relative">
                                                                            {tenant?.status}
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                                <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                                    <p className="text-gray-900 whitespace-no-wrap">
                                                                    {tenant?.created_at}
                                                                    </p>
                                                                </td>
                                                                <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                                    <span className={`relative inline-block px-3 py-1 font-semibold leading-tight ${!tenant?.mode ? "text-green-900" : "text-red-900"}`}>
                                                                        <span aria-hidden="true" className={`absolute inset-0 rounded-full opacity-50 ${!tenant?.mode ? "bg-green-200" : "bg-red-200"}`}>
                                                                        </span>
                                                                        <span className="relative">
                                                                            {!tenant?.mode ? "Active" : "Terminated"}
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                                <td className="pr-2 py-5 text-sm bg-white border-b border-gray-200">
                                                                    <div>
                                                                    <Dropdown>
                                                                        <Dropdown.Trigger>
                                                                            <span className="inline-flex rounded-md">
                                                                                <button
                                                                                    type="button"
                                                                                    className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-slate-500 bg-white hover:text-slate-700 focus:outline-none transition ease-in-out duration-150"
                                                                                >
                                                                                    <HiOutlineDotsVertical className="h-4 w-4 font-medium" />

                                                                                </button>
                                                                            </span>
                                                                        </Dropdown.Trigger>

                                                                        <Dropdown.Content>
                                                                            {!tenant?.status_val ?
                                                                            <Dropdown.Link href={route('tenant.activate', {tenant})} method="post" as="button" className="text-green-500" >
                                                                            Activate Once
                                                                            </Dropdown.Link>
                                                                            :
                                                                            <Dropdown.Link href={route('tenant.backup', {tenant})} method="post" as="button">
                                                                            Backup Database
                                                                            </Dropdown.Link>
                                                                            }

                                                                            {!tenant?.mode ?
                                                                            <Dropdown.Link href={route('tenant.terminate', {tenant})} method="post" as="button">
                                                                            Terminate Tenant
                                                                            </Dropdown.Link>
                                                                            :
                                                                            tenant?.status_val ?
                                                                            <Dropdown.Link href={route('tenant.recover', {tenant})} method="post" as="button">
                                                                            Recover Tenant
                                                                            </Dropdown.Link>
                                                                            :
                                                                            <span></span>
                                                                            }

                                                                            <Dropdown.Link href={route('tenant.destroy', {tenant})} method="delete" as="button" className="text-red-500">
                                                                            Permanent Delete
                                                                            </Dropdown.Link>

                                                                        </Dropdown.Content>
                                                                    </Dropdown>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}

                                                        {data.length === 0 && (
                                                            <tr>
                                                                <td colSpan={7} className="p-5 mx-auto text-center text-red-500 text-sm bg-white border-b border-gray-200">
                                                                    No data found!
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                {/* <div className="flex flex-col items-center px-5 py-5 bg-white xs:flex-row xs:justify-between">
                                                    <div className="flex items-center">
                                                        <button type="button" className="w-full p-4 text-base text-gray-600 bg-white border rounded-l-xl hover:bg-gray-100">
                                                            <svg width="9" fill="currentColor" height="8" className="" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M1427 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z">
                                                                </path>
                                                            </svg>
                                                        </button>
                                                        <button type="button" className="w-full px-4 py-2 text-base text-indigo-500 bg-white border-t border-b hover:bg-gray-100 ">
                                                            1
                                                        </button>
                                                        <button type="button" className="w-full px-4 py-2 text-base text-gray-600 bg-white border hover:bg-gray-100">
                                                            2
                                                        </button>
                                                        <button type="button" className="w-full px-4 py-2 text-base text-gray-600 bg-white border-t border-b hover:bg-gray-100">
                                                            3
                                                        </button>
                                                        <button type="button" className="w-full px-4 py-2 text-base text-gray-600 bg-white border hover:bg-gray-100">
                                                            4
                                                        </button>
                                                        <button type="button" className="w-full p-4 text-base text-gray-600 bg-white border-t border-b border-r rounded-r-xl hover:bg-gray-100">
                                                            <svg width="9" fill="currentColor" height="8" className="" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z">
                                                                </path>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AuthenticatedLayout>
  )
}

export default ManageTenants
